/**
 * 小程序中要使用到的一些页面
 */
export default {
  routes: [
    {
      path: '/applet/other-order',
      name: 'OtherOrder',
      meta: {
        title: '其他订单'
      },
      component: () => import(/* webpackChunkName: "applet" */ '../views/applet/OtherOrder.vue')
    },
    {
      path: '/applet/sample-setting',
      name: 'SampleSetting',
      meta: {
        title: '设置'
      },
      component: () => import(/* webpackChunkName: "applet" */ '../views/applet/SampleSetting.vue')
    },
    {
      path: '/applet/privacy-setting',
      name: 'SampleSetting',
      meta: {
        title: '隐私设置'
      },
      component: () => import(/* webpackChunkName: "privacySetting" */ '../views/applet/PrivacySetting.vue')
    }
  ]
}
